import type { EitherTranslatedOrError, SimpleFormatMessage } from 'components/secondaryMarket/shared/Clipboard/types';

export const translateNumber = (pastedValue: string, formatMessage: SimpleFormatMessage, _: unknown) => {
  const parsed = Number.parseFloat(pastedValue);
  if (!Number.isNaN(parsed)) {
    return { status: 'success', value: parsed } as EitherTranslatedOrError<number>;
  }
  const error = formatMessage('moreMenu.pasteFromClipboard.error.invalidNumber', { text: pastedValue });
  return { status: 'error', error } as EitherTranslatedOrError<number>;
};
